import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Radio } from '@material-ui/core';
import cn from 'classnames';
import { CURRENCY_SYMBOLS } from '../../../../constants';

import useStyles from './makeStyles';

const AmountCompensation = ({ availableLimits, selectedLimit, setSelectedLimit }) => {
  const classes = useStyles();

  const handleRadioChange = (event) => {
    const selectedValue = event.target.value;
    const newSelectedLimit = availableLimits.find((limit) => limit.id === selectedValue);
    setSelectedLimit(newSelectedLimit);
  };

  return (
    <div className={classes.container}>
      {availableLimits.map((limit) => (
        <div key={limit.id} className={classes.radioButtonWrapper}>
          <FormControlLabel
            value={limit.id}
            control={(
              <Radio
                checked={selectedLimit.id === limit.id}
                className={cn(
                  classes.radioButton,
                  selectedLimit.id === limit.id && classes.checked,
                )}
              />
            )}
            onChange={handleRadioChange}
            label={`${CURRENCY_SYMBOLS[limit.currency.toUpperCase()]} ${limit.value.toLocaleString(
              'en-US',
            )}`}
            classes={{
              label: cn(classes.label, selectedLimit.id === limit.id && classes.selectedLabel),
            }}
          />
        </div>
      ))}
    </div>
  );
};

AmountCompensation.propTypes = {
  availableLimits: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      currency: PropTypes.string,
      value: PropTypes.number,
    }),
  ).isRequired,
  selectedLimit: PropTypes.shape({
    id: PropTypes.string,
    currency: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
  setSelectedLimit: PropTypes.func.isRequired,
};

export default AmountCompensation;
